<div class="mood-table-container">
  <table class="table table-hover">
    <thead>
      <th>ID</th>
      <th>Date</th>
      <th>Weight</th>
      <th>Food</th>
      <th>Sport</th>
    </thead>
    <tbody>
      @for (weight of weights; track weight.id) {
        <tr (click)="select(weight, content)">
          <td>{{weight.id}}</td>
          <td>{{weight.date}}</td>
          <td>{{weight.weight}}</td>
          <td>{{weight.food}}</td>
          <td>{{weight.sport}}</td>
        </tr>
      }
    </tbody>
  </table>
</div>

<div>
  <button class="btn btn-success" (click)="selectNew(content)">Insert</button>
</div>

<div class="chart-section">
  <div class="chart">
    <canvas height="200"
      baseChart
      [data]="chartData"
      [type]="lineChartType"
      [options]="chartOptions"
      >
    </canvas>
  </div>
</div>

<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Set Weight</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form>
      <div class="form-group">
        <label for="date">Date</label>
        <div class="input-group">
          <input id="date" class="form-control" placeholder="yyyy-mm-dd" name="dp" ngbDatepicker
            #dp="ngbDatepicker" [(ngModel)]="currentEntry.date">
          <div class="input-group-append">
            <button class="btn btn-outline-secondary calendar" (click)="dp.toggle()" type="button"></button>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label for="mood">Weight</label>
        <input id="mood" class="form-control" name="mood" type="number" [(ngModel)]="currentEntry.weight">
      </div>
      <div class="form-group">
        <label for="food">Food</label>
        <input id="food" class="form-control" name="food" type="text" [(ngModel)]="currentEntry.food">
      </div>
      <div class="form-group">
        <label for="sport">Sport</label>
        <input id="sport" class="form-control" name="sport" type="text" [(ngModel)]="currentEntry.sport">
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="modal.close('Save click')">Save</button>
  </div>
</ng-template>
